const DEFAULT_API_ERROR = 'Не удалось выполнить запрос. Попробуйте еще раз.'

const STATUS_MESSAGES = {
  400: 'Запрос не прошел проверку. Проверьте данные и попробуйте еще раз.',
  401: 'Сессия истекла. Войдите в систему заново.',
  403: 'Недостаточно прав для выполнения действия.',
  404: 'Запрошенные данные не найдены.',
  500: 'На сервере произошла ошибка. Попробуйте позже.',
}

const isPlainObject = (value) =>
  value !== null && typeof value === 'object' && !Array.isArray(value)

const stringifyMessage = (value) => {
  if (!value && value !== 0) return ''
  if (typeof value === 'string') return value
  if (typeof value === 'number' || typeof value === 'boolean') return String(value)
  return ''
}

const formatFieldValue = (value) => {
  if (Array.isArray(value)) {
    return value.map(formatFieldValue).filter(Boolean).join(' ')
  }

  if (isPlainObject(value)) {
    return Object.entries(value)
      .map(([key, nestedValue]) => {
        const message = formatFieldValue(nestedValue)
        return message ? `${key}: ${message}` : ''
      })
      .filter(Boolean)
      .join(' ')
  }

  return stringifyMessage(value)
}

export const getApiErrorData = (error) => error?.response?.data ?? error?.data ?? error

export const getApiErrorMessage = (error, fallback = DEFAULT_API_ERROR) => {
  const data = getApiErrorData(error)
  const status = error?.response?.status ?? error?.status

  if (!data) {
    return STATUS_MESSAGES[status] || error?.message || fallback
  }

  if (typeof data === 'string') {
    return data || STATUS_MESSAGES[status] || fallback
  }

  if (Array.isArray(data)) {
    const messages = data.map((item) => getApiErrorMessage(item, fallback)).filter(Boolean)
    return messages.length > 0 ? messages.join(' ') : STATUS_MESSAGES[status] || fallback
  }

  if (data instanceof Error) {
    return data.message || STATUS_MESSAGES[status] || fallback
  }

  if (isPlainObject(data)) {
    const message = data.message || data.detail || data.error || data.non_field_errors

    if (message) {
      const formattedMessage = formatFieldValue(message)

      if (formattedMessage) {
        if (Number.isInteger(data.item_index)) {
          return `${formattedMessage} Позиция корзины: ${data.item_index + 1}.`
        }
        return formattedMessage
      }
    }

    const fieldMessages = Object.entries(data)
      .map(([field, value]) => {
        if (['code', 'item_index'].includes(field)) return ''

        const fieldMessage = formatFieldValue(value)
        return fieldMessage ? `${field}: ${fieldMessage}` : ''
      })
      .filter(Boolean)

    return fieldMessages.length > 0 ? fieldMessages.join(' ') : STATUS_MESSAGES[status] || fallback
  }

  return STATUS_MESSAGES[status] || error?.message || fallback
}

export const normalizeApiError = (error, fallback = DEFAULT_API_ERROR) => {
  if (!error || typeof error !== 'object') {
    return {
      isApiError: true,
      userMessage: getApiErrorMessage(error, fallback),
      originalError: error,
    }
  }

  error.isApiError = true
  error.userMessage = getApiErrorMessage(error, fallback)
  error.apiMessage = error.userMessage
  error.apiData = getApiErrorData(error)
  error.status = error?.response?.status ?? error.status
  error.code = error?.apiData?.code ?? error.code

  return error
}

export default getApiErrorMessage
